(function () {
    "use strict";

    angular.module('app').factory('objectToUrlParametersService', ObjectToUrlParametersService);

    ObjectToUrlParametersService.$inject = ['$window', '$location'];
    function ObjectToUrlParametersService($window, $location) {

        return {
            setUrlParamToFilter: setUrlParamToFilter,
            fillObjectWithUrlParameters: fillObjectWithUrlParameters,
            ParseSearchParameters: parseSearchParameters
        };

        /**
         * Pure function for loading the GET parameters
         * @returns Object containing SearchParams
         */
        function parseSearchParameters() {
            const urlParams = new URLSearchParams($window.location.search);
            return Object.fromEntries(urlParams);
        }

        function setUrlParamToFilter(searchObject) {
            const search = angular.copy(searchObject);
            for (const key in search) {
                if (search[key] && search[key].constructor === Array)
                    search[key] = search[key].join();
            }
            $location.search(search);
        }

        function fillObjectWithUrlParameters(object) {
            const urlParams = new URLSearchParams($window.location.search);
            // Convert parameters to object - display the key/value pairs
            object = Object.fromEntries(urlParams);
            return object;
        }
    }
})();